<div class="tou-cotainer">
  <div class="tou-modal-window">
    <div class="tou-header">
      <span class="fw-700">{{ touDisplayName }}</span>
      <img
        *ngIf="ShowCloseButton"
        class="c-p"
        src="./assets/icons/close-white.svg"
        alt=""
        (click)="RejectTOU()"
      />
    </div>
    <div class="tou-modal-body" *ngIf="tou.length > 0">
      <div class="tou-inner-body">
        <rmp-html-viewer
          [content]="tou"
          [fullWidth]="true"
          (downloadRequested)="PrintTOU($event)"
          [hasBorder]="false"
        ></rmp-html-viewer>
      </div>
    </div>
    <div class="tou-modal-footer">
      <button
        type="button"
        class="button button-light"
        (click)="StartPdfGeneration()"
      >
        <img src="./assets/icons/print.svg" alt="" />
        Print
      </button>
      <button
        *ngIf="ShowCloseButton"
        type="button"
        class="button button-light"
        (click)="RejectTOU()"
      >
        Reject
      </button>
      <button
        type="button"
        class="button button-dark alertbtnwidth"
        (click)="AcceptTOU()"
      >
        Accept
      </button>
    </div>
  </div>
</div>
